// extracted by mini-css-extract-plugin
module.exports = {"pagination-button-next":"styles_pagination-button-next__hgsdw"};